export default {
    login_register: 'Kirjaudu/Rekisteröidy',
    booking_confirmation_title: 'Varausvahvistus',
    booking_confirmation_body: 'Kiitos varauksestasi. Löydät vahvistuksen tiedot alta.',
    insurance_requirements_modal_disclaimer: `Tekemällä tämän varauksen vahvistan, että: minulla ei ole ollut tuomioita tai liikennerikkomuksia viimeisen 5 vuoden aikana. Minulta ei ole evätty vakuutusta, peruutettu vakuutusta tai evätty uusimista, eikä minulta ole vaadittu korkeampaa maksua tai asetettu erityisehtoja minkään vakuutusyhtiön toimesta. Minua ei ole määrätty ajokieltoon. Minulla ei ole vireillä oikeusjuttuja tai poliisitutkintaa. Minulla ei ole tuomioita varkaus-, petos- tai epärehellisyysrikoksista viimeisen 5 vuoden aikana. En kärsi näkö- tai kuulovammasta (jota ei korjata silmälaseilla tai kuulolaitteella), sydänsairaudesta, diabeteksesta, kohtauksista tai mistään fyysisestä tai henkisestä sairaudesta. Minulla ei ole ollut onnettomuuksia viimeisen 5 vuoden aikana. Klikkaa {0}, jos et täytä näitä vaatimuksia.`,
    insurance_requirements_here: 'tästä',
    insurance_requirements: 'Olen lukenut ja ymmärtänyt {0}',
    ir: 'Vakuutusvaatimukset',
    location: 'Sijainti',
    pickup_location: 'Noutopaikka',
    dropoff_location: 'Palautuspaikka',
    vehicle: 'Ajoneuvo',
    pickup_and_dropoff: 'Nouto ja palautus (paikallista aikaa)',
    view_voucher: 'Näytä kuitti',
    identity_verification_body: 'Sinun tulee vahvistaa henkilöllisyytesi ennen ajoneuvon noutoa',
    identity_verification_title: 'Vahvista henkilöllisyys',
    search_again: 'Etsi uudelleen',
    refrigerated: 'jäädytetty',
    aircon_lower: 'ilmastointi',
    aircon: 'Ilmastointi',
    refrigeration: 'Jäädytetty',
    not_available: 'Drive & Go on tällä hetkellä saatavilla vain seuraavien maiden henkilöllisyys- ja ajokorttidokumenteilla.',
    check_if_included: 'Tarkista, onko maasi mukana.',
    included_in_booking: 'Sisältyy tähän varaukseen',
    cdw_with_excess: 'CDW omavastuulla',
    theft_protection: 'Varkaussuoja omavastuulla',
    risk_reduction: 'Riskin vähennys',
    free_extras: 'Saat kaksi ilmaista lisäpalvelua <br /> tämän varauksen yhteydessä.',
    continue: 'Jatka',
    luggage_large_short_label: 'I',
    luggage_medium_short_label: 'K',
    luggage_small_short_label: 'P',
    luggage_large_long_label: 'iso',
    luggage_medium_long_label: 'keskikokoinen',
    luggage_small_long_label: 'pieni',
    fuel_unspecified_label: 'määrittelemätön',
    transmission_manual_label: 'Manuaali',
    transmission_automatic_label: 'Automaatti',
    make_a_booking: 'Tee varaus',
    pickup_date: 'Noutopäivä',
    dropoff_date: 'Palautuspäivä',
    driver_age: 'Kuljettaja 30–65 vuotta',
    enter_driver_age: 'Syötä kuljettajan ikä',
    promo_code: 'Alennuskoodi',
    search: 'Etsi',
    dropoff_date_cannot_be_before_pickup_date: 'Palautuspäivä ei voi olla ennen noutopäivää',
    pickup_date_cannot_be_in_the_past: 'Noutopäivä ei voi olla menneisyydessä',
    pickup_time_cannot_be_in_the_past: 'Noutoaika ei voi olla menneisyydessä',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Palautusajan tulee olla noutoajan jälkeen, jos kyseessä on sama päivä',
    vehicle_filters: 'Ajoneuvosuodattimet',
    reset: 'Nollaa',
    transmission: 'Vaihteisto',
    all: 'Kaikki',
    manual: 'Manuaali',
    auto: 'Automaatti',
    passengers: 'Matkustajat',
    vehicle_type: 'Ajoneuvotyyppi',
    filter: 'Suodata',
    vehicle_search: 'Ajoneuvohaku',
    edit: 'Muokkaa',
    no_results: 'Ei tuloksia hakuehdoilla.',
    small_cars: 'Pienet autot',
    medium_cars: 'Keskikokoiset autot',
    large_cars: 'Isot autot',
    estate_cars: 'Farmarit',
    suvs: 'SUV:t',
    mpvs: 'MPV:t',
    vans: 'Pakettiautot',
    camper_vans: 'Asuntoautot',
    premium: 'Premium',
    unspecified: 'määrittelemätön',
    large: 'iso',
    medium: 'keskikokoinen',
    small: 'pieni',
    automatic: 'automaatti',
    you_have_been_refunded: 'Sinulle on palautettu maksu.',
    please_customer_service: 'Ota yhteyttä asiakaspalveluun tehdäksesi varauksen.',
    contact_customer_service: 'Ota yhteyttä asiakaspalveluun',
    booking_failed: 'Varausta ei voitu käsitellä tällä kertaa.',
    summary: 'Yhteenveto',
    reforestation_and_protection: 'Tue Costa Rican sademetsien uudelleenmetsitystä ja suojelua',
    cost_of_rental: 'Vuokran hinta',
    to_pay_now: 'Maksettavaa nyt',
    greenheart_donation: 'Green Heart -lahjoitus',
    total_cost: 'Vuokran kokonaishinta',
    tc_agreement: 'Olen lukenut ja ymmärtänyt {0}.',
    tc: 'Ehdot',
    receive_offers: 'Haluan saada erikoistarjouksia sähköpostitse.',
    donate: 'Kyllä, haluan lahjoittaa {amount}',
    pay_now: 'Maksa {amount} nyt',
    driver_details: 'Kuljettajan tiedot',
    complete_driver_details: 'Täytä kuljettajan tiedot.',
    are_you_the_driver: 'Oletko kuljettaja?',
    have_an_account: 'Onko sinulla jo tili?',
    login: 'Kirjaudu',
    or: 'tai',
    first_name: 'Kuljettajan etunimi',
    last_name: 'Kuljettajan sukunimi',
    email: 'Sähköpostiosoite',
    phone_number: 'Matkapuhelinnumero',
    unable_to_save_driver_information: 'Kuljettajan tietoja ei voitu tallentaa. Yritä uudelleen.',
    pay_online_now: 'Maksa nyt',
    day: 'Päivä',
    choose_location: 'Valitse sijainti',
    location_not_found: 'Valitettavasti pyytämääsi sijaintia ei löytynyt.',
    add: 'Lisää',
    remove: 'Poista',
    free_extra: 'Ilmainen lisäpalvelu',
    free: 'ILMAINEN!',
    fast_track_notice: 'Tämän palvelun käyttöön liittyy asiakirjavaatimuksia. Saatavilla vain henkilöille, joilla on asiakirjat maasta',
    complete_booking: 'Viimeistele varaus',
    choose_card: 'Valitse kortti tai lisää uusi.',
    add_billing_details: 'Lisää laskutustiedot.',
    card_number: 'Kortin numero',
    card_holder_name: 'Kortinhaltijan nimi',
    card_exp: 'KK / VV',
    card_cvc: 'CVC',
    save_card: 'Tallenna kortti?',
    amount_charged: 'Kortiltasi veloitetaan',
    payment_confirmation: 'Vahvista varaus ja maksa',
    payment_methods: 'käytettävissä olevat maksutavat',
    use_saved_card: 'x käytä tallennettua korttia',
    use_different_card: '+ käytä toista korttia',
    book_now: 'Varaa nyt',
    minimum_age: 'Vain yli {age}-vuotiaille',
    excess_liability: 'Omavastuu',
    security_deposit: 'Takuumaksu',
    fuel_policy: 'Polttoainekäytäntö',
    like_for_like: 'Sama tankki palautettaessa',
    full_to_full: 'Täysi-täysi',
    miles_per_rental: '{mileage} ilmaista mailia/vuokraus',
    km_per_rental: '{mileage} ilmaista km/vuokraus',
    unlimited_mileage: 'Rajoittamaton ajomatka',
    unlimited_mileage_km: 'Rajoittamattomat kilometrit',
    non_amendable: 'Ei muutettavissa',
    non_refundable: 'Ei palautettavissa',
    free_cancellation_until: 'Ilmainen peruutus asti',
    cancellation_in_line_with: 'Peruutus ehtojen mukaisesti',
    tcs: 'Ehdot',
    free_extras_on_collection: 'Kaksi ilmaista lisäpalvelua noudettaessa',
    glass_and_tyres_covered: 'Lasit ja renkaat katettu',
    number_of_passengers: 'Matkustajien määrä',
    number_of_bags: 'Laukkujen määrä',
    fuel_type: 'Polttoainetyyppi',
    co2: 'CO2',
    book_type: 'Varaa {type}',
    processing: 'Käsitellään',
    actual_price: 'Todellinen hinta',
    tooltip: 'Hinta valuutassa {currencyCode} on arvio, {currency}-hinta on sitova.',
    deposit: 'Takuumaksu',
    pay_online: 'Maksa nyt',
    pay_online_without_extras: 'Vuokrahinta',
    extras_on_arrival: 'Lisäpalvelut paikan päällä',
    insurance_on_arrival: 'Riskin vähennys - maksa paikan päällä',
    insurance_online: 'Riskin vähennys - maksa nyt',
    extras_online: 'Lisäpalvelut - maksa nyt',
    green_heart_donation: 'Green Heart -lahjoitus',
    why_use_drive_and_go: 'Miksi käyttää Drive & Go -palvelua?',
    straight_to_car: 'Suoraan autolle',
    no_queues: 'Ei jonoja',
    self_checkout: 'Itsepalvelu',
    cant_lose_key: 'Avain ei voi kadota',
    online_id_check: 'Verkkotunnistautuminen',
    phone_as_key: 'Puhelin avaimena',
    premiumplus_benefits_includes: 'Sisältää myös Premium Plus+ -edut',
    book_drive_go: 'Varaa Drive & Go',
    distance_allowance: 'Sallittu ajomatka',
    duration: 'Kesto',
    view_more_bookings: 'Näytä lisää varauksia',
    to_pay_on_arrival: 'Maksettava paikan päällä',
    pay_on_arrival: 'Maksa paikan päällä',
    unlimited: 'Rajoittamaton',
    return_date: 'Palautuspäivä',
    postcode: 'Postinumero',
    country: 'Maa',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'Drive & Go on tällä hetkellä saatavilla vain seuraavien maiden henkilöllisyys- ja ajokorttidokumenteilla:',
        drive_and_go_today: 'Drive & Go -varaus tälle päivälle!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Miksi käyttää Drive & Go -palvelua?',
        straight_to_car: 'Suoraan autolle',
        no_queues: 'Ei jonoja',
        self_checkout: 'Itsepalvelu',
        cannot_lose_the_key: 'Avain ei voi kadota',
        online_id_check: 'Verkkotunnistautuminen',
        phone_as_a_key: 'Puhelin avaimena',
        premium_plus_benefits_also_included: 'Sisältää myös Premium Plus+ -edut',
        book_drive_and_go: 'Varaa Drive & Go',
    },
    car_and_camp: {
        tent_and_equipment: 'Teltta ja varusteet',
        quick_and_easy: 'Nopea ja helppo pystyttää',
        travel_freedom: 'Matkustusvapaus',
        affordable_campervan_alternative: 'Edullinen vaihtoehto asuntoautolle',
        lightweight_and_compact: 'Kevyt ja kompakti',
        fully_insured: 'Täysin vakuutettu',
    },
    my_bookings: 'Oma varaus',
    no_bookings: 'Ei varauksia',
    my_profile: 'Oma profiili',
    no_bookings_to_display: 'Ei näytettäviä varauksia.',
    search_great_car_rental_deals: 'Etsi loistavia autonvuokraustarjouksia seuraavaa matkaasi varten.',
    odometer_at_collection: 'Mittarilukema noudettaessa',
    fuel_at_collection: 'Polttoaine noudettaessa',
    start_check_in: 'Aloita sisäänkirjautuminen',
    start_collection: 'Aloita nouto',
    recent_bookings: 'Viimeisin varaus',
    damage: {
        updated_damage_report_submitted: 'Päivitetty vahinkoraportti on lähetetty. Asiakaspalvelumme ottaa yhteyttä tarvittaessa.',
        add_additional_damage: 'Lisää vahinko',
        you_may_report_additional_damage_up_to: 'Voit ilmoittaa lisävahingoista 24 tunnin sisällä palautuksesta',
        specify_damage: 'Määritä vahinko',
        please_choose_the_area_and_type_of_damage: 'Valitse vahingon alue ja tyyppi',
        type_of_damage: 'Vahingon tyyppi',
        is_this_more_than_5_cm: 'Onko tämä yli 5 cm?',
        please_take_or_select_a_photo: 'Ota tai valitse kuva',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Ota kuva niin, että vahinko näkyy selvästi',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Tarvittaessa voit lisätä toisen kuvan, valitse kuvake lisätäksesi kuvan',
        save_image: 'Tallenna kuva',
        save_images: 'Tallenna kuvat',
        damage_saved_successfully: 'Vahinko tallennettu onnistuneesti',
        add_photo: 'Lisää kuva',
    },
    checkout: {
        start_collection: 'Aloita nouto',
        collect_vehicle: 'Nouda ajoneuvo',
        we_will_let_you_know_the_details: 'Ilmoitamme sinulle sijainnin ja tiedot, jotta löydät vuokra-ajoneuvon.',
        inspect: 'Tarkasta',
        we_will_ask_for_four_photos_from_each_corner: 'Pyydämme neljä kuvaa jokaisesta kulmasta sekä mahdollisista uusista vahingoista.',
        fuel_and_milage: 'Polttoaine & mittarilukema',
        you_confirm_the_readings_at_the_start_of_your_hire: 'Vahvistat mittarilukeman ja polttoainetason vuokrauksen alussa.',
        sign: 'Allekirjoita',
        sign_the_rental_agreement: 'Allekirjoita vuokrasopimus.',
        away_you_go: 'Hyvää matkaa',
        you_are_free_to_take_to_the_road: 'Voit lähteä matkaan!',
        collect_your_vehicle: 'Nouda ajoneuvosi',
        get_directions: 'Hae reittiohjeet',
        hide_directions: 'Piilota ohjeet',
        local_time: 'paikallista aikaa',
        tel: 'Puh',
        getting_to_the_location: 'Saapumisohjeet',
        get_vehicle_details: 'Hae ajoneuvon tiedot',
        view_map: 'Näytä kartta',
        unlock_vehicle_and_continue: 'Avaa ajoneuvo & jatka',
        unable_to_connect_to_vehicle: 'Ei yhteyttä ajoneuvoon',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Emme saaneet yhteyttä ajoneuvoon – tarkista, että olet oikean ajoneuvon vieressä, ja yritä uudelleen.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Emme löytäneet ajoneuvovarausta. Yritä myöhemmin uudelleen.',
        odometer_and_fuel: 'Mittarilukema & polttoaine',
        odometer: 'Mittarilukema',
        please_confirm_the_odometer_and_fuel_readings: 'Vahvista mittarilukema ja polttoainetaso, jos mahdollista.',
        the_odometer_field_is_required: 'Mittarilukema on pakollinen',
        and_must_be_greater_than_the_checkout_odometer: 'ja sen tulee olla suurempi kuin noudettaessa',
        confirm: 'Vahvista',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Ota kuva jokaisesta ajoneuvon kulmasta',
        pre_existing_damage: 'Aiemmat vahingot',
        no_pre_existing_damage: 'Ei aiempia vahinkoja.',
        new_damage: 'Uusi vahinko',
        add_additional_damage: 'lisää vahinko',
        no_new_damage_to_report: 'Ei uusia vahinkoja ilmoitettavana',
        checkout_complete: 'Nouto valmis',
        start_rental: 'Aloita vuokraus',
        congratulations_name_it_is_time_to_take_to_the_road: 'Onnittelut {customer_name}, on aika lähteä matkaan!',
        we_are_unable_to_complete_your_vehicle_checkout: 'Emme voi viimeistellä ajoneuvon noutoa.',
        please_do_the_following: 'Tee seuraavat toimenpiteet',
        remove_all_belonging_and_lock_the_vehicle: 'Poista kaikki tavarat ja lukitse ajoneuvo.',
        lock_vehicle: 'Lukitse ajoneuvo',
        once_you_have_contacted_customer_services: 'Kun olet ottanut yhteyttä asiakaspalveluun',
        vehicle_location: 'Ajoneuvon sijainti',
        collect_your: 'Nouda',
        from: 'Paikasta',
        key_in_glove_box: 'avaimesi on hansikaslokerossa',

        keyholder: {
            not_detected: 'Avainta ei havaittu avainpidikkeessä',
            not_detected_please_try_again: 'Aseta avain avainpidikkeeseen ja yritä uudelleen.',

            not_installed: 'Avainpidikettä ei ole asennettu',
            not_installed_please_contact_customer_service: 'Avainpidikettä ei ole asennettu, ota yhteyttä asiakaspalveluun.',
        },
        keyring: {
            look_up_failed: 'Avaimen tunnistus epäonnistui',
            look_up_failed_please_contact_customer_service: 'Avaimen tunnistus epäonnistui, ota yhteyttä asiakaspalveluun.',
        },
        key: {
            invalid: 'Avain ei kelpaa',
            invalid_please_contact_customer_service: 'Avaimesi ei kelpaa, ota yhteyttä asiakaspalveluun.',

            expired: 'Avain on vanhentunut',
            expired__please_contact_customer_service: 'Avaimesi on vanhentunut, ota yhteyttä asiakaspalveluun.',
        },
    },
    checkin: {
        start_check_in: 'Aloita sisäänkirjautuminen',
        vehicle_location: 'Ajoneuvon sijainti',
        tell_us_where_you_have_parked: 'Kerro, mihin pysäköit ajoneuvon.',
        fuel_and_milage: 'Polttoaine & mittarilukema',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Vahvistat mittarilukeman ja polttoainetason vuokrauksen lopussa.',
        inspect: 'Tarkasta',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Pyydämme neljä kuvaa jokaisesta kulmasta sekä mahdollisista uusista vahingoista vuokrauksen aikana.',
        lock: 'Lukitse',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Tarkista, ettei tavaroita jäänyt ja lukitse ajoneuvo.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Kerro, mihin pysäköit ajoneuvon',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Kun ajoneuvo on lukittu, sitä ei voi enää avata.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle:
            '{first_name}, tarkista ettei tavaroita jäänyt, lukitse ajoneuvo ja palauta fyysinen avain avainpidikkeeseen tarvittaessa.',
        lock_vehicle: 'Lukitse ajoneuvo',
        complete_check_in: 'Viimeistele sisäänkirjautuminen',
        inspection: 'Tarkastus',
        complete_vehicle_check_in: 'Viimeistele ajoneuvon sisäänkirjautuminen',
        we_are_unable_to_complete_your_vehicle_check_in: 'Emme voi viimeistellä ajoneuvon sisäänkirjautumista.',
        please_contact_customer_services: 'Ota yhteyttä asiakaspalveluun',
        once_you_have_contacted_customer_services: 'Kun olet ottanut yhteyttä asiakaspalveluun',
        please_amend_odometer_to_be_greater_than: 'Korjaa mittarilukema suuremmaksi kuin {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Vuokrasopimus',
        agreement_between: 'Sopimus osapuolten välillä',
        and: 'ja',
        sign_rental_agreement: 'Allekirjoita vuokrasopimus',
        i_have_read_and_understood_the_terms_and_conditions: 'Olen lukenut ja ymmärtänyt ehdot ja hyväksyn ajoneuvon kunnon',
    },
    additional_options: 'Lisävalinnat',
    booking_details: 'Varaustiedot',
    price_for_x_days: 'Hinta {qty_of_days} päivälle | Hinta {qty_of_days} päivälle',
    cancelled: 'Peruutettu',
    upcoming: 'Tuleva',
    active: 'Aktiivinen',
    full_insurance_no_deposit: 'Täysi vakuutus & ei takuuta',
    excess: '{amount} omavastuu',
    deposit: '{amount} takuumaksu',
    included_daily_distance: '{distance} {unit} päivässä',
    miles: 'mailia',
    kilometers: 'kilometriä',
    collection_details_title: 'Noutotiedot',
    collection_details_not_found: 'Tälle sijainnille ei ole määritelty noutotietoja',
    free_cancellation: 'Ilmainen peruutus',
    no_deposit: 'Ei takuuta',
    benefit_from: 'Hyödynnä',
    for_only_per_day: 'Vain {price} päivässä',
    upgrade_mee: 'UpgradeMee',
};
